<script setup lang="ts">
const labs = [
  'London',
  'Dhaka',
  'Barcelona',
  // 'Istanbul',
  // 'New York'
]

const emit = defineEmits(['success'])
const showError = ref<boolean>(false)

const { getRecaptchaToken } = useGoogleRecaptcha()

const mail = useMail()

const loading = ref<boolean>(false)

async function handleSubmit(e: Event) {
  e.preventDefault()

  if (!e.target) return

  const data = new FormData(e.target as HTMLFormElement)
  const json = Object.fromEntries(data.entries())

  try {
    loading.value = true

    // Send the form to the API
    const token = await getRecaptchaToken('submit')
    if (!token) return

    // Format the email content
    const emailBody = `
        New Contact Request

        Name: ${json['full-name']}
        Email: ${json['email']}
        Phone: ${json['phone']}
        Company: ${json['company']}
        Country: ${json['country']}

        Lab:
        ${json['lab']}

        Date:
        ${json['date']}

        Message:
        ${json['message']}
    `

    const file = (data.get('file') as File) ?? null
    const toBase64 = (file: File): Promise<string> =>
      new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result?.toString().split(',')[1] || '')
        reader.onerror = (error) => reject(error)
      })

    const fileBase64 = await toBase64(file)

    const isImage = file.type.startsWith('image/')

    const filePreview = isImage
      ? `<div style="margin-top: 20px;">
     <p style="font-weight: bold;">📎 Attached Image Preview:</p>
     <img src="data:${file.type};base64,${fileBase64}" alt="${file.name}" style="max-width: 100%; border: 1px solid #ccc; padding: 4px; border-radius: 4px;" />
   </div>`
      : `<div style="margin-top: 20px;">
     <p style="font-weight: bold;">📎 File Attached:</p>
     <p>${file.name}</p>
   </div>`

    const htmlBody = `
  <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; border: 1px solid #ddd; background-color: #f9f9f9;">
  <h2 style="color: #333;">📬 New Contact Request</h2>

  <table style="width: 100%; border-collapse: collapse;">
    <tr><td style="padding: 8px; font-weight: bold;">Name:</td><td style="padding: 8px;">${json['full-name']}</td></tr>
    <tr><td style="padding: 8px; font-weight: bold;">Email:</td><td style="padding: 8px;">${json['email']}</td></tr>
    <tr><td style="padding: 8px; font-weight: bold;">Phone:</td><td style="padding: 8px;">${json['phone']}</td></tr>
    <tr><td style="padding: 8px; font-weight: bold;">Company:</td><td style="padding: 8px;">${json['company']}</td></tr>
    <tr><td style="padding: 8px; font-weight: bold;">Country:</td><td style="padding: 8px;">${json['country']}</td></tr>
    <tr><td style="padding: 8px; font-weight: bold;">Lab:</td><td style="padding: 8px;">${json['lab']}</td></tr>
    <tr><td style="padding: 8px; font-weight: bold;">Date (MM-DD-YYYY):</td><td style="padding: 8px;">${json['date']}</td></tr>
  </table>

  <div style="margin-top: 20px;">
    <p style="font-weight: bold;">Message:</p>
    <p style="white-space: pre-wrap; background: #fff; padding: 10px; border: 1px solid #ccc; border-radius: 4px;">${json['message']}</p>
  </div>

  ${file ? filePreview : ''}
  </div>
  `
    // Send email via API
    mail.send({
      from: 'nitex@nitex.com',
      replyTo: json['email'] as string,
      subject: `New Inquiry from ${json['full-name'] || json['commpany']}`,
      text: emailBody,
      html: htmlBody,
      attachments: [
        {
          filename: file.name,
          content: fileBase64,
          encoding: 'base64',
        },
      ],
    })
    emit('success')
  } catch (error) {
    console.error('error:', error)
    showError.value = true
  }
}
</script>

<template>
  <form class="px-bleed lg:gap-gap lg:grid lg:grid-cols-2" @submit="handleSubmit">
    <div class="mb-16">
      <div class="mb-16">
        <p class="font-display mb-6 text-xl uppercase font-stretch-expanded">Select lab</p>
        <div class="flex flex-wrap gap-x-2 gap-y-3">
          <CommonInputRadio v-for="(lab, index) in labs" :key="index" :label="lab" :name="'lab'" />
        </div>
      </div>

      <div>
        <p class="font-display mb-6 text-xl uppercase font-stretch-expanded">
          select preferred date
        </p>
        <CommonInputDate />
      </div>
    </div>

    <FormsBase :show-form-error="showError" :loading="loading" :include-file-input="true" />
  </form>
</template>
